<template>
  <div class="empty">
    <!-- placeholder -->
  </div>
</template>

<script>

import {
  defineComponent,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductGtm',
  props: {
    productData: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    categoryId: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    pageTitleGtm: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$gtm.push({
        event: 'ViewContent',
        content_name: this.pageTitleGtm,
        content_url: `${window.location.origin}${this.$route.fullPath}`,
        ...this.productData.productDataGtm,
        ecommerce: {
          actionField: {
            list: this.productData.productDataGtm.category,
          },
          detail: {
            ...this.categoryId,
          },
          PageType: 'product-page',
        },
      });
    });
  },
});
</script>

<style scoped>

</style>
